/**
 * Draw the selected Compass product mark into a jsPDF document.
 *
 * Coordinates mirror CompassLogoCHybrid's 24x24 SVG geometry. Keeping this
 * renderer vector-based preserves sharp edges at every PDF zoom level.
 */
export default function drawCompassLogo(doc, x, y, size = 16) {
  const scale = size / 24;
  const point = (value) => value * scale;

  doc.setDrawColor(...PDF_STONE.primary);
  doc.setFillColor(...PDF_STONE.primary);
  doc.setLineWidth(point(2));
  doc.setLineCap("round");
  doc.setLineJoin("round");

  // Open ring: SVG path "M20.31 7.2A9.6 9.6 0 1 0 20.31 16.8".
  // Four cubic curves approximate the SVG arc while leaving its short east gap.
  doc.lines(
    [
      [point(-2.1725), point(-3.7629), point(-6.6015), point(-5.5975), point(-10.7985), point(-4.4729)],
      [point(-4.197), point(1.1246), point(-7.1153), point(4.9279), point(-7.1153), point(9.2729)],
      [0, point(4.345), point(2.9184), point(8.1483), point(7.1153), point(9.2729)],
      [point(4.197), point(1.1246), point(8.626), point(-0.71), point(10.7985), point(-4.4729)],
    ],
    x + point(20.3138),
    y + point(7.2),
    [1, 1],
    "S"
  );

  // Solid directional needle: SVG path
  // "M17 6.5 13.8 14.2 7 17.5 10.2 9.8Z".
  doc.lines(
    [
      [point(-3.2), point(7.7)],
      [point(-6.8), point(3.3)],
      [point(3.2), point(-7.7)],
      [point(6.8), point(-3.3)],
    ],
    x + point(17),
    y + point(6.5),
    [1, 1],
    "F",
    true
  );

  // Knock the center out against the PDF page to match SVG even-odd fill.
  doc.setFillColor(255, 255, 255);
  doc.circle(x + point(12), y + point(12), point(1.15), "F");
}
import { PDF_STONE } from "./pdfTheme";
